import { render } from "./NewArea.vue?vue&type=template&id=ecb08856&scoped=true"
import script from "./NewArea.vue?vue&type=script&lang=js"
export * from "./NewArea.vue?vue&type=script&lang=js"

import "./NewArea.vue?vue&type=style&index=0&id=ecb08856&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecb08856"]])

export default __exports__